import { render, staticRenderFns } from "./AnnouncementsTable.vue?vue&type=template&id=2931d692&"
import script from "./AnnouncementsTable.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports